import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
export function VideoSection() {
  useEffect(() => {
    // Load Vimeo player API
    if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  return <section className="py-20 bg-white" data-id="element-123">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-126">
            What Our Clients Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-127">
            Hear directly from a boat dealer and see how a custom-built website
            can transform your online presence and drive real results.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="rounded-xl overflow-hidden shadow-2xl border border-slate-300" data-id="element-128">
          <div style={{
          padding: '56.25% 0 0 0',
          position: 'relative'
        }} data-id="element-129">
            <iframe src="https://player.vimeo.com/video/1102984649?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }} title="Boats by George - Mannix Marketing Testimonial" data-id="element-130" />
          </div>
        </motion.div>
      </div>
    </section>;
}